import styles from './appPromoQuizPartyCard.module.scss';
import waveTop from './border-wave-top.svg';
import quizPartyLogo from './quiz-party-logo.svg';

export default function AppPromoQuizPartyCard({ content, onClick, onClose }) {
  const { titleText, subText, btnText, closeText } = content;
  return (
    <div className={styles.container}>
      <img src={waveTop} className={styles.wave} alt="" role="presentation" />
      <div className={styles.inner}>
        <p className={styles.title}>{titleText}</p>
        <div className={styles.logoRow}>
          <img src={quizPartyLogo} className={styles.logo} alt="Quiz Party" />
          <div className={styles.logoText}>
            <p className={styles.secondaryText}>{subText}</p>
          </div>
        </div>
        <div className={styles.button} onClick={() => onClick()}>{btnText}</div>
        <div className={styles.close} onClick={() => onClose()}>{closeText}</div>
      </div>
    </div>
  );
}
